import React from "react";
import { Modal, Button } from "react-bootstrap";

const ProfileModal = ({
  handleChange,
  user,
  profileType,
  borderColor,
  handleApplyJob,
  show,
}) => (
  <div className={`static-modal ${!show && "hidden"}`}>
    <Modal.Dialog>
      <Modal.Header>
        <Modal.Title>Select your profile</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <select
          id="singleSelect"
          name="profile_type"
          className="form-control form-control-lg"
          value={profileType}
          onChange={handleChange}
          style={{ borderColor: borderColor }}
        >
          <option value="0">Select your profile</option>
          {user &&
            user.profiles &&
            user.profiles.map((profile) => {
              return (
                <option value={profile.id} key={profile.id}>
                  {profile.title}
                </option>
              );
            })}
        </select>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={() => handleApplyJob("open")}>Apply</Button>
        <Button onClick={handleApplyJob}>Close</Button>
      </Modal.Footer>
    </Modal.Dialog>
  </div>
);

export default ProfileModal;
